export default function Partners() {
  return (
    <div className="min-h-screen pt-[72px]">
      <div className="container-page section-py">
        <h1 className="text-4xl font-bold">Çözüm Ortaklarımız</h1>
        <p className="mt-4 text-foreground-500">Sayfa yapım aşamasında...</p>
      </div>
    </div>
  );
}